import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CptClientDataGrid } from './CptClientDataGrid';
import { ReactNode } from 'react';
import { PropsWithChildren } from 'react';

interface KeldomAlertDialogProps {
  title: string;
  onValidate: Function;
  validateDisabled: boolean;
}

export function KeldomAlertDialog({
  title,
  onValidate,
  validateDisabled,
  children,
}: PropsWithChildren<KeldomAlertDialogProps>) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog maxWidth={'xl'} fullWidth open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button
            onClick={() => onValidate()}
            autoFocus
            disabled={validateDisabled}
          >
            Valider le changement
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
